<script lang="ts">
  import type {FillInTheBlankList, CurrentResponses, QuestionOnChange} from '../types';
  import {getDisplayValue} from '../utils';
  export let question: FillInTheBlankList;
  export let pageQuestionIdx: string;
  export let onChange: QuestionOnChange;
  export let currentResponses: CurrentResponses;

  $: label = getDisplayValue<FillInTheBlankList>(currentResponses, question, 'label');
  let state = (currentResponses[pageQuestionIdx] as string[]) || [''];
</script>

<fieldset
  on:blur={() => {
    state = state.filter((x) => x.length);
    onChange({newValue: state});
  }}
>
  <div class="flex flex-col">
    {#each state as option, idx}
      <div class="flex items-center">
        <button
          class="border-2 inline px-2 rounded-full h-8 w-8 hover:border-sky-400 dark:text-white"
          on:click|preventDefault={() => {
            state = state.filter((_, jdx) => idx !== jdx);
            onChange({newValue: state});
          }}>X</button
        >
        <button
          class="border-2 inline px-2 mr-2 rounded-full h-8 w-8 hover:border-sky-400 dark:text-white"
          on:click|preventDefault>✓</button
        >
        <div class="flex flex-col">
          <label for={`option-${pageQuestionIdx}-${idx}`} class="text-xs dark:text-white">Fill in here</label>
          <input
            class="border-2"
            name={label}
            id={`option-${pageQuestionIdx}-${idx}`}
            bind:value={option}
            on:change={() => onChange({newValue: state})}
            on:keypress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                if (option.length) {
                  state = [...state, ''];
                }
              }
            }}
          />
        </div>
      </div>
    {/each}
    <button
      class="border-2 w-max inline px-2 my-2 hover:border-sky-400 dark:text-white dark:border-slate-200"
      on:click|preventDefault={() => {
        state = [...state, ''];
      }}>add another</button
    >
  </div>
</fieldset>
